import { withPrefix } from 'gatsby'

export default {
  metadata: {
    title: 'Support your administrators with workflow automation. - artificial',
    desc: 'Use the artificialOS platform to take care of the post-bind policy life cycle from start to finish and reduce manual effort for administrators.',
  },
  ArHeroHeader: {
    animation: {
      id: 'manage_hero',
    },
    title: 'Accelerating workflow',
    description: 'Tools to help manage and maintain your portfolio.',
    cta: {
      label: 'Request a demo',
    },
  },
  ArTextWithImage: {
    items: [
      {
        title: 'Speed up your workflow',
        description: [
          'Use the ',
          { tag: 'strong', options: { innerText: 'artificialOS' } },
          ' platform to take care of the post-bind policy life cycle from start to finish.',
          { tag: 'br' },
          { tag: 'br' },
          'Enjoy a faster workflow with a single-entry data system and view real time operational performance stats on our beautiful integrated dashboard.',
        ],
        images: [
          { url: withPrefix('img/ArTextWithImage13.png'), alt: 'Artificial Intelligence for insurance policy and claims management' },
          { url: withPrefix('img/ArTextWithImage13.png'), alt: 'Artificial Intelligence for insurance policy and claims management' },
          { url: withPrefix('img/ArTextWithImage13.png'), alt: 'Artificial Intelligence for insurance policy and claims management' },
        ],
        scImageMargins: {
          right: ['0', '0', '0'],
          bottom: ['75px', '0'],
          left: ['0', '0'],
        },
        scComponentMargins: {
          top: ['100px', '100px', '200px'], // TODO: tweak 'top' config when Hero will be present
          bottom: ['0', '0', '0'],
        },
        scGap: [0, 25, 170],
        scFlexAlign: 'flex-end',
      },
    ],
  },
  ArTextWithImageStacked: {
    items: [
      {
        title: 'Easier portfolio management',
        description: [
          'Reduce the manual effort required to manage and maintain your entire portfolio using the latest Machine Learning techniques.',
          { tag: 'br' },
          { tag: 'br' },
          'SLA workflow automation supports your administrators by helping them to easily prioritise actions that need to be undertaken, identify bottlenecks in the portfolio, and streamline high volume/low margin claims.',
        ],
        animation: {
          id: 'manage_portfolio',
        },
        scComponentMargins: {
          top: ['14px', '21px', '200px'],
          bottom: ['40px', '0', '0'],
        },
        scTitleBottomMargins: ['20px', '27px', '30px'],
        scDesktopGap: 80 - 40,
        scInverseStack: true,
        scCenterTextOnDesktop: true,
        scTextWrapperMaxWidthOnDesktop: '600px',
        scDescMaxWidth: [null, null, '600px'],
      },
    ],
  },
  Ar3ColFeatures: {
    title: 'Post-bind policy management',
    description: 'The artificialOS platform lets you oversee every aspect of the post-bind policy life cycle:',
    features: [
      {
        image: {
          alt: 'Premiums',
          url: withPrefix('img/Ar3ColFeatures1.png'),
        },
        title: 'Premiums',
        description: 'Organise transactional payments, reconciliation and follow-ups',
        scHideOnMobile: false,
      },
      {
        image: {
          alt: 'Subjectivities',
          url: withPrefix('img/Ar3ColFeatures2.png'),
        },
        title: 'Subjectivities',
        description: 'Faster and simpler housekeeping for subjectivities and compliance',
        scHideOnMobile: false,
      },
      {
        image: {
          alt: 'Claims',
          url: withPrefix('img/Ar3ColFeatures3.png'),
        },
        title: 'Claims',
        description: 'Straightforward claims management integrated with policy data',
        scHideOnMobile: true,
      },
      {
        image: {
          alt: 'Complaints & Appeals',
          url: withPrefix('img/Ar3ColFeatures4.png'),
        },
        title: 'Complaints & Appeals',
        description: 'Manage complaints and appeals within a defined regulatory framework',
        scHideOnMobile: false,
      },
      {
        image: {
          alt: 'Endorsements',
          url: withPrefix('img/Ar3ColFeatures5.png'),
        },
        title: 'Endorsements',
        description: 'Mid-term policy amendments and associated impact on portfolio',
        scHideOnMobile: false,
      },
      {
        image: {
          alt: 'Renewals',
          url: withPrefix('img/Ar3ColFeatures6.png'),
        },
        title: 'Renewals',
        description: 'Automated renewals for high customer retention rates',
        scHideOnMobile: true,
      },
      {
        image: {
          alt: 'Cancellations',
          url: withPrefix('img/Ar3ColFeatures7.png'),
        },
        title: 'Cancellations',
        description: 'Workflow to support mid-term cancellations and impact on portfolio',
        scHideOnMobile: false,
      },
      {
        image: {
          alt: 'Bordereau Reporting',
          url: withPrefix('img/Ar3ColFeatures8.png'),
        },
        title: 'Bordereau Reporting',
        description: 'Generate Bordereau reports compliant with the latest Lloyd\'s coverholder standards',
        scHideOnMobile: false,
      },
      {
        image: {
          alt: 'Eligibility Checks',
          url: withPrefix('img/Ar3ColFeatures9.png'),
        },
        title: 'Eligibility Checks',
        description: 'Automated processing of claim eligibility checks',
        scHideOnMobile: true,
      },
    ],
  },
  ArTextWithImageHalvedOnTablet: {
    items: [
      {
        title: 'Harness AI for better decision-making',
        description: [
          'Claim Automation takes the hard work out of deciding whether a claim should be accepted or rejected.',
          { tag: 'br' },
          { tag: 'br' },
          'Using Machine Learning, our application helps you optimise profits by recognising and summarising the content of claims documents and continuously learning patterns to suggest improvements for future decision making.',
        ],
        image: {
          alt: 'Insurance claim automation with AI',
          url: withPrefix('img/ArTextWithImage9.png'),
        },
        scComponentMargins: {
          top: ['40px', '50px', '92px'],
          bottom: ['0', '0', '0'],
        },
        scTitleBottomMargins: ['20px', '30px', '30px'],
        scImageMargins: {
          right: ['13px', '-32.1%', '45px'],
          bottom: ['40px', '0', '0'],
          left: [`13px`, `0`, '0'],
        },
        scImageWidth: [null, 546, 540],
        scGap: [0, 17, 155],
      },
      {
        title: 'Analyse productivity and efficiency in real time',
        description: [
          'Our platform gives your business the insight and analytics to monitor your portfolio and its performance in real time.',
          { tag: 'br' },
          { tag: 'br' },
          'Integrated dashboards show what matters most to your customers, so you can identify what needs to be reviewed and refined.',
          { tag: 'br' },
          { tag: 'br' },
          'The platform also gives you a clear visualisation of key performance indicators so any improvements can be implemented with maximum efficiency.',
        ],
        image: {
          alt: 'Insurance portfolio data visualisation',
          url: withPrefix('img/ArTextWithImage10.png'),
        },
        scComponentMargins: {
          top: ['40px', '80px', '160px'],
          bottom: ['40px', '80px', '160px'],
        },
        scTitleBottomMargins: ['20px', '30px', '30px'],
        scImageMargins: {
          right: ['13px', '0', '0'],
          bottom: ['40px', '0', '0'],
          left: ['13px', '-36%', '0'],
        },
        scImageWidth: [null, 566, 560],
        scGap: [0, 49, 180],
      },
    ],
  },
}
